<template>
    <b-col v-if="item.status !== 'comingSoon'" cols="6" lg="3" class="col-menu" :class="{'not-jackpot' : jackpot === 0 }">
        <a href="javascript:void(0)" class="game-item" :class="{'no-jackpot': jackpot <= 0}"
        @click.prevent="popup=$playGame(item, $route.fullPath)">
            <div class="thumb">
<!--                <s-img v-if="item.partner_game_id==='ktf1990' && isLabelEvent" class="label" src="/assets/img/event/icon-event.svg" alt="event"/>-->
                <dImg class="featured" :src="item.image" alt="game"/>
                <div v-if="jackpot > 0" class="game-amount flex-box">
                    <img :src="`${this.$store.state.mapDomain.STATIC_URL}/assets/img/games-page/coin.png`" alt="icon" loading=lazy>
                    <animated-number
                            :value="jackpot"
                            :formatValue="formatToPrice"
                            :duration="1000"
                    />
                </div>
            </div>
            <div class="content">
                <div class="game-name">
                    <div class="heading" :title="item.name">{{ item.name }}</div>
                </div>
                <span href="javascript:void(0)" class="button">CHƠI NGAY</span>
            </div>
        </a>
    </b-col>
</template>

<script>
import AnimatedNumber from 'animated-number-vue';
// eslint-disable-next-line import/no-unresolved
import { numberWithCommas } from '~/helper/index.js';
// eslint-disable-next-line import/no-unresolved
import dImg from '~/components/image.vue';

export default {
    props: ['item'],
    data() {
        return {
        };
    },
    components: {
        AnimatedNumber,
        dImg
    },
    computed: {
        jackpot() {
            if (this.$store.state.jackpot[this.item.partner_game_id]) {
                return this.$store.state.jackpot[this.item.partner_game_id];
            }
            return 0;
        },
        isLabelEvent() {
            return process.env.ENABLE_LABEL_EVENT && process.env.ENABLE_LABEL_EVENT === '1';
        }
    },
    methods: {
        formatToPrice(value) {
            return numberWithCommas(value.toFixed(0));
        }
    }
};
</script>
